// Global front-end feature switches. Keep in sync with the backend flag
// "Features:WearAndTearAndAdtEnabled" (see Classes/FeatureFlags.cs).
//
// When false, Wear & Tear (W&T) and Additional Drive Time (ADT) fields, columns and
// banners are hidden throughout the UI. The code is left in place so the feature can be
// re-enabled by flipping this flag (and the matching backend config) back on.
export const WT_ADT_ENABLED = false;
